import React, { useState, useEffect } from "react";
import { Table, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useAppContext } from "../../context/appContext";
import { isViewOnly } from "../../utils/permissions";
import { Paginate } from "../../components";
import { EditUserModal, DeleteUserModal } from "./UpdateUser";

const UsersListPage = ({
  env,
  handleEnvChange,
  users,
  tenants,
  isLoading,
  isError,
  pageResetFlag,
  currentTenant,
  onUserUpdate,
  onUserDelete
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const { user } = useAppContext();
  const viewOnly = isViewOnly(user);

  const itemsPerPage = 20;
  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentUsers = users?.slice(indexOfFirstUser, indexOfLastUser);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = users?.length ? Math.ceil(users?.length / itemsPerPage) : 0;

  const handleEditClick = (selectedUser) => {
    setSelectedUser(selectedUser);
    setShowModal(true);
  };

  const handleDeleteClick = (selectedUser) => {
    setSelectedUser(selectedUser);
    setShowDeleteModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedUser(null);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [pageResetFlag, users]);

  const isUserActive = (inactive) => (inactive == null || inactive === false || inactive === "false" ? "True" : "False");

  if (isLoading || isError) {
    return isLoading ? (
      <Container>
        <p>Loading users...</p>
      </Container>
    ) : (
      <Container>
        <p className="text-danger">Error loading users.</p>
      </Container>
    );
  }

  return (
    <Container fluid>
      <Table striped bordered hover responsive className="table-sm">
        <thead>
          <tr>
            <th scope="col">Email</th>
            <th scope="col">First Name</th>
            <th scope="col">Last Name</th>
            <th scope="col">Tenant</th>
            <th scope="col">UUID</th>
            <th scope="col">Role</th>
            <th scope="col">Active?</th>
            <th scope="col" style={{ width: "80px" }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {currentUsers?.map((user) => (
            <tr key={user?.email}>
              <td>{user?.email}</td>
              <td>{user?.firstName}</td>
              <td>{user?.lastName}</td>
              <td>{user?.tenantName}</td>
              <td>{user?.id}</td>
              <td>{user?.role.name}</td>
              <td>{isUserActive(user?.isInactive)}</td>
              <td>
                <div className="d-flex justify-content-around align-items-center" style={{ minWidth: "80px" }}>
                  {viewOnly ? (
                    <FontAwesomeIcon icon={faEye} style={{ cursor: "pointer" }} onClick={() => handleEditClick(user)} />
                  ) : (
                    <>
                      <FontAwesomeIcon
                        icon={faEdit}
                        style={{ cursor: "pointer", marginRight: "10px" }}
                        onClick={() => handleEditClick(user)}
                      />
                      <FontAwesomeIcon icon={faTimes} style={{ cursor: "pointer", color: "red" }} onClick={() => handleDeleteClick(user)} />
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {!isLoading && !isError && <Paginate currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />}

      {selectedUser && (
        <>
          <EditUserModal
            show={showModal}
            user={selectedUser}
            handleClose={handleCloseModal}
            viewOnly={viewOnly}
            handleEnvChange={handleEnvChange}
            tenants={tenants}
            isLoading={isLoading}
            isError={isError}
            env={env}
            onUserUpdate={onUserUpdate}
          />
          <DeleteUserModal show={showDeleteModal} user={selectedUser} handleClose={handleCloseDeleteModal} onUserDelete={onUserDelete} />
        </>
      )}
    </Container>
  );
};

export default UsersListPage;
